import './styles.css'

export default function Button ({onclick, title, classname = 'none', externo = false}) {
    return(
        <button className={externo?`${classname} externo`:classname} id='button' onClick={onclick}>{title}</button>
    )
}